
<!-- displaying changeorgid error message -->
<div *ngIf="showorgidFailError" class="container-box" id="error-container">
  <div class="alert valign-children-middle mar-top-20" id="alert-container">
    <div class="alert-error" aria-label="Alert." id="alert-error-container">
      <i class="icon-badgealert" aria-hidden="true"></i>
    </div>
    <div id="error-message-container">
      <!-- <h2 tabindex="-1" id="error-heading">Error</h2> -->
      <h2>Error</h2>
      <p>
        Organization ID update failed. Check entry and retry. If issue
        continues, contact support at 866.563.4703 .
      </p>
    </div>
  </div>
</div>
<!-- displaying error message -->
<div *ngIf="showNewnotifyFailureError" class="container-box" id="error-container">
  <div class="alert valign-children-middle mar-top-20" id="alert-container">
    <div class="alert-error" aria-label="Alert." id="alert-error-container">
      <i class="icon-badgealert" aria-hidden="true"></i>
    </div>
    <div id="error-message-container">
      <!-- <h2 tabindex="-1" id="error-heading">Error</h2> -->
      <p id="error-message">Error</p>
      <p id="error-message">
        Notification settings update failed. Check entry and retry. If issue
        continues, contact support at 866.563.4703 .
      </p>
    </div>
  </div>
</div>

<main *ngIf="!oemStatus" aria-labelledby="deviceInventoryMainContainer" [ngClass]="{
    'device-inventory-page': !(deviceInventoryData && data && showLIC)
  }">
  <div *ngIf="showError" class="alert valign-children-middle error-alert" role="alert">
    <div class="alert-error" role="img" aria-label="Error">
      <i class="icon-badgealert" role="img" aria-label="Error"></i>
    </div>
    <div class="alert-content">
      {{ deviceInventoryData.errorMessage }}
      <!--We've encountered following error: Backend time out. Please <a class="reload" onclick="window.location.reload()">reload this page</a>-->
    </div>
    <button class="close" (click)="showError = !showError" aria-label="Close"></button>
  </div>

  <div *ngIf="deviceInventoryData && ctnTable && singleFanInventory.fan" class="device-inventory">
    <h1 id="deviceInventoryMainContainer">
      {{ deviceInventoryData.heading }} {{ singleFanInventory.fan }}
    </h1>
    <div *ngIf="initModal">
      <app-modal *ngIf="showSupport" [showModal]="showSupport" [modalClass]="modalClass">
        <app-confirm-modal [modalPopupObject]="confirmModalPopup" [triggerElement]="eventEmit"
          (modalOutput)="closeModal($event)">
        </app-confirm-modal>
      </app-modal>
    </div>
    <!-- <div class="alert valign-children-middle" *ngIf="smsSent">
      <div class="alert-success">
        <i class="icon-approval" role="img" aria-label="Success" tabindex="0"></i>
      </div>
      <div>Your message has been sent.</div>
      <div class="pull-right close" (click)="dismissInfo()" role="img" aria-label="close" tabindex="0"></div>
    </div> -->
    <section *ngIf="singleFanInventory.fan">
      <div class="participation">
        <span class="inventory-label">{{
          deviceInventoryData.profileLabel
          }}</span>
        <a class="profile" (click)="viewProfile()" href="javascript:void(0)">{{
          singleFanInventory.profile
          }}</a>
      </div>
      <div class="participation">
        <span class="inventory-label">{{
          deviceInventoryData.participationLabel
          }}</span>
        {{
        !singleFanInventory.newDeviceEffectiveDate
        ? deviceInventoryData.noDateSetLabel
        : singleFanInventory.newDeviceEffectiveDate
        }}
      </div>
      <div class="existParticipation">
        <span class="inventory-label">{{
          deviceInventoryData.existParticipationLabel
          }}</span>
        {{
        !singleFanInventory.existDeviceEffectiveDate
        ? deviceInventoryData.noDateSetLabel
        : singleFanInventory.existDeviceEffectiveDate
        }}
      </div>
      <div class="cancel-participation" *ngIf="!oemStatus">
        <a (click)="cancelPaticipation()" href="javascript:void(0)"
          [checkRole]="deviceInventoryData.fieldPermissions.cancelParticipation">
          {{ deviceInventoryData.cancelParticipation }}</a>
      </div>
    </section>
    <!-- <div class='download-terms'>
           <a [checkRole]='deviceInventoryData.fieldPermissions.downloadTermsandConditions' href='javascript:void(0)' >{{deviceInventoryData.downloadTermsandConditions}}</a>
       </div>  -->
    <div class="clearfix"></div>
    <hr />
    <section class="panel-container">
      <section class="progress-bar" *ngIf="singleFanInventory.fan">
        <div class="status-bar" *ngIf="!singleFanInventory.hideDeviceChart">
          <app-status-bar [data]="progressChartData" [leftLabel]="leftLabel"></app-status-bar>
        </div>
        <div class="legend-data" *ngIf="progressChartData.length > 0">
          <app-legend class="col-sm-6 col-md-6" [data]="legendData.left"></app-legend>
          <app-legend class="col-sm-6 col-md-6" [data]="legendData.right"></app-legend>
        </div>
      </section>

      <hr class="lite line hr-line" />
      <section *ngIf="oemStatus === false" class="nav-container-block"
        [ngClass]="{ 'navs-container': !progressChartData.length && !isMobile }">
        <ul class="nav-icon">
          <li *ngFor="let nav of deviceInventoryData.navLinks">
            <button class="link-button" type="button" (click)="navigate(nav.route)" [disabled]="nav.disable">
              <figure>
                <img [src]="nav.imgUrl" alt="image icon for {{ nav.label }}" />
              </figure>
              <a [innerHtml]="nav.label"></a>
            </button>
          </li>
        </ul>
      </section>
      <section *ngIf="oemStatus === true" class="nav-container-block"
        [ngClass]="{ 'navs-container': !progressChartData.length && !isMobile }">
        <ul class="nav-icon">
          <li *ngFor="let nav of deviceInventoryData.navOEMLinks">
            <button class="link-button" type="button" (click)="navigate(nav.route)" [disabled]="nav.disable">
              <figure>
                <img [src]="nav.imgUrl" alt="image icon for {{ nav.label }}" />
              </figure>
              <a [innerHtml]="nav.label"></a>
            </button>
          </li>
        </ul>
      </section>
      <div class="clearfix"></div>
    </section>
    <hr />
    <div class="row enrollDateInfoold">
      <div class="alert-icon-ibm">
        <i aria-label="Alert" class="icon-alert .ico" role="img"></i>
      </div>
      <div class="extra-content-ibm">
        <span [innerHTML]="deviceInventoryData.enrollDatePopup.pageText"></span>
        <a href="javascript:void(0);" title="Opens a dialog" (click)="showenroll()">{{
          deviceInventoryData.enrollDatePopup.pageLinkText }}</a>
      </div>
    </div>
    <div *ngIf="showEnrollDetailsModal">
      <app-modal [showModal]="showEnrollDetailsModal">
        <app-confirm-modal [modalPopupObject]="enrollDatePopup" [triggerElement]="eventEmit"
          (modalOutput)="closePopupModal($event)">
        </app-confirm-modal>
      </app-modal>
    </div>
    <h2 class="sub-headerold">{{ deviceInventoryData.subHeading }}</h2>
    <app-custom-grid-extended [gridOptions]="gridOptions" (gridEvent)="gridEventChanges($event)"
      (onDataChange)="onRowClick($event)"></app-custom-grid-extended>
    <div *ngIf="showPopup">
      <app-modal [showModal]="showPopup" [modalClass]="modalClass">
        <app-confirm-modal [modalPopupObject]="confirmModalPopup" [triggerElement]="eventEmit"
          (modalOutput)="closeModal($event)">
        </app-confirm-modal>
      </app-modal>
    </div>
    <!--Report pop up functionality -->
    <div *ngIf="showReportPopup">
      <app-modal [showModal]="showReportPopup" [modalClass]="modalClass">
        <app-report [modalPopupObject]="overviewModalPopup" [triggerElement]="eventEmit"
          (modalOutput)="closeReportPopup($event)">
        </app-report>
      </app-modal>
    </div>
    <div *ngIf="showOverviewModal">
      <app-modal [showModal]="showOverviewModal" [modalClass]="modalClass">
        <div class="model-cover terms">
          <div class="model-box">
            <div class="modal-header">
              <div class="corner-button">
                <button class="close" aria-label="Close" (click)="closeOverviewModal()">
                  x
                </button>
              </div>
              <att-gvp [attr.video]="videoId"></att-gvp>
            </div>
          </div>
        </div>
      </app-modal>
    </div>
    <div class="accordion-section" *ngIf="!oemStatus && supportArticle">
      <app-accordion [accordion]="options" [accordionController]="false">
        <app-accordion-list *ngFor="let option of options; let i = index" [option]="option" [isSubAccordion]="true">
          <div class="support-content mediaStop" id="player"
            *ngFor="let article of this.article.availableArticle; let i = index">
            <!-- <a href="javascript:void(0)"  (click)="getSupportContent(i)" >{{article.name}}</a> -->
            <att-gvp *ngIf="article.url" [attr.video]="article.url"></att-gvp>
          </div>
        </app-accordion-list>
      </app-accordion>
    </div>
  </div>
</main>
<main *ngIf="oemStatus" aria-labelledby="deviceInventoryMainContainer" [ngClass]="{
    'device-inventory-page': !(deviceInventoryData && data && showLIC)
  }">
  <div *ngIf="showError" class="alert valign-children-middle error-alert" role="alert">
    <div class="alert-error" role="img" aria-label="Error">
      <i class="icon-badgealert" role="img" aria-label="Error"></i>
    </div>
    <div *ngIf="!failuremessage" class="alert-content">
      {{ deviceInventoryData.errorMessage }}
    </div>
    <!--We've encountered following error: Backend time out. Please <a class="reload" onclick="window.location.reload()">reload this page</a>-->
    <div *ngIf="failuremessage" class="alert-content">
      {{ deviceInventoryData.failureMessage }}
    </div>
    <button class="close" (click)="showError = !showError" aria-label="Close"></button>
  </div>

  <div *ngIf="deviceInventoryData && ctnTable && singleFanInventory.fan" class="device-inventory">
    <div class="col-md-7" class="h1-content">
      <h1 class="heading1" id="deviceInventoryMainContainer">
        <strong> {{ deviceInventoryData.heading }}</strong>
      </h1>
    </div>

    <div *ngIf="smsSent" class="device-inventory1">
      <div class="alert valign-children-middle" id="alert-success-container">
        <div class="alert-success">
          <i class="icon-approval" aria-hidden="true"></i>
        </div>
        <div id="success-message-container">
          <h4>Your message has been sent.</h4>
          <div class="pull-right close" (click)="dismissInfo()" role="img" aria-label="close" tabindex="0"></div>
        </div>
      </div>
    </div>
    <!-- displaying notification success message -->
    <div *ngIf="showNotifyError" class="device-inventory1" id="success-main-container">
      <div class="alert valign-children-middle" id="alert-success-container">
        <div class="alert-success">
          <i class="icon-approval" aria-hidden="true"></i>
        </div>
        <div id="success-message-container">
          <h2>Success</h2>
          <p>Notification settings updated successfully.</p>
          <div class="pull-right close" (click)="dismissInfo()" role="img" aria-label="close" tabindex="0"></div>
        </div>
      </div>
    </div>

    <div *ngIf="formSuccessGrp" id="success-main-container">
      <div class="device-inventory1" id="success-container">
        <div class="alert valign-children-middle" id="alert-success-container">
          <div class="alert-success">
            <i class="icon-approval" aria-hidden="true"></i>
          </div>
          <div id="success-message-container">
            <h2 tabindex="-1" id="success-heading">
              The device(s) have been successfully moved to a group.
            </h2>
            <div class="pull-right close" (click)="dismissInfo()" role="img" aria-label="close" tabindex="0"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- displaying changeorgid success message -->
    <div *ngIf="showorgidsuccessmsg" id="success-main-container">
      <div class="device-inventory1" id="success-container">
        <div class="alert valign-children-middle" id="alert-success-container">
          <div class="alert-success">
            <i class="icon-approval" aria-hidden="true"></i>
          </div>
          <div id="success-message-container">
            <h2>Success</h2>
            <p>Organization ID updated successfully.</p>
            <div class="pull-right close" (click)="dismissInfo()" role="img" aria-label="close" tabindex="0"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- displaying enroll success message -->
    <div *ngIf="formSuccess" id="success-main-container">
      <div class="device-inventory1" id="success-container">
        <div class="alert valign-children-middle" id="alert-success-container">
          <div class="alert-success">
            <i class="icon-approval" aria-hidden="true"></i>
          </div>
          <div id="success-message-container">
            <h2 tabindex="-1" id="success-heading">
              {{ deviceInventoryData.successMessage }}
            </h2>
            <div class="pull-right close" (click)="dismissInfo()" role="img" aria-label="close" tabindex="0"></div>
          </div>
        </div>
      </div>
    </div>

    <div>
      <div class="alert valign-children-middle" *ngIf="manageGroupFlag || groupDeviceFlag">
        <div class="alert-error" aria-label="Alert.">
          <i aria-hidden="true" class="icon-badgealert"></i>
        </div>
        <div>
          <h2>We are loading your device data, please wait.</h2>
          <div class="pull-right close" (click)="dismissInfo()" role="img" aria-label="close" tabindex="0"></div>
        </div>
      </div>

      <div class="col-md-7 removepadding h2-content">
        <h2 class="heading2" id="deviceInventorySecondaryContainer">
          <strong>{{ deviceInventoryData.headingoem }}
            {{ singleFanInventory.fan }}</strong>
        </h2>
      </div>
    </div>

    <hr class="lite line hr-line" />

    <div *ngIf="initModal">
      <app-modal *ngIf="showSupport" [showModal]="showSupport" [modalClass]="modalClass">
        <app-confirm-modal [modalPopupObject]="confirmModalPopup" [triggerElement]="eventEmit"
          (modalOutput)="closeModal($event)">
        </app-confirm-modal>
      </app-modal>
    </div>
    <!-- <div class="alert valign-children-middle" *ngIf="smsSent">
      <div class="alert-success">
        <i class="icon-approval" role="img" aria-label="Success" tabindex="0"></i>
      </div>
      <div>Your message has been sent.</div>
      <div class="pull-right close" (click)="dismissInfo()" role="img" aria-label="close" tabindex="0"></div>
    </div> -->

    <section *ngIf="singleFanInventory.fan">
      <div class="participation col-md-7 removepadding">
        <div class="grid-table" cellspacing="0">
          <table class="table tableoem">
            <tr>
              <td class="inventory-label">
                <strong>{{ deviceInventoryData.notifications }}</strong>
                {{ singleFanInventory.comPref }}
              </td>
              <td *ngIf="!addpAllow">
                <a href="manageInventory/managenotification" [ngClass]="{'disable-url':disableLinks}"
                  (click)="selectedProfile()">
                  {{ deviceInventoryData.changeText }}
                </a>
              </td>
            </tr>

            <tr>
              <td class="inventory-label">
                <strong>Total Device Groups:</strong> {{ totalGroupCount }}
              </td>
              <td *ngIf="!addpAllow">
                <a href="javascript:void(0)" [ngClass]="{'disable-url':disableLinks}" (click)="continueManageGroup()">
                  Manage Groups
                </a>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <!-- <div class='participation'><span class="inventory-label">{{deviceInventoryData.existingDevices}}</span> </div>
               <div class='participation'><span class="inventory-label">{{deviceInventoryData.notifications}}</span></div> -->
      <br />
    </section>

    <section class="panel panel-header panel-padding programs-row-container" style="min-height: 250px; padding: 20px">
      <div class="flex-container-multiple-program">
        <div class="tileHeader" *ngIf="deviceSummaryData[0].fan.emmProductCode === 'DMPGZTP'">
          <strong>Android™ Zero-touch</strong>
        </div>
        <div class="tileHeader" *ngIf="deviceSummaryData[0].fan.emmProductCode === 'DMPSKME'">
          <strong>Knox Mobile Enrollment</strong>
        </div>
        <div class="tileHeader" *ngIf="deviceSummaryData[0].fan.emmProductCode === 'DMPAABM'">
          <strong>Apple Business</strong>
        </div>

        <div class="tileProgram">
          <div style="margin-bottom: 20px" *ngIf="deviceSummaryData[0].fan.emmProductCode === 'DMPGZTP'">
            <span class="programEnroll smallMobile">GOOGLE ID: {{ deviceSummaryData[0].fan.emmAccountId }}</span>
          </div>
          <div style="margin-bottom: 20px" *ngIf="deviceSummaryData[0].fan.emmProductCode === 'DMPSKME'">
            <span class="programEnroll smallMobile">Knox Enrollment ID:
              {{ deviceSummaryData[0].fan.emmAccountId }}</span>
          </div>
          <div style="margin-bottom: 20px" *ngIf="deviceSummaryData[0].fan.emmProductCode === 'DMPAABM'">
            <span class="programEnroll smallMobile">Apple Organization ID:
              <!-- {{ deviceSummaryData[0].fan.emmAccountId }} -->
              {{ deviceSummaryData[0].fan.emmAccountId ? deviceSummaryData[0].fan.emmAccountId : "Pending"}}
            </span>
            <ng-container *ngIf="!addpAllow && abm"><a
                [ngClass]="{'disable-url':  !deviceSummaryData[0].fan.emmAccountId}" class="abm-change-link"
                (click)="selectedFan(deviceSummaryData[0].fan.emmAccountId)">
                {{ deviceInventoryData.change }}
              </a></ng-container>
          </div>

          <div *ngIf="enrollStatusArr && enrollStatusArr.length > 0 && enrollStatusArr[0]">
            <span class="programEnroll smallMobile">{{ deviceInventoryData.existingDevices }}
              {{ deviceInventoryData.existingDevicesValue }}</span>
            <ng-container *ngIf="!addpAllow && enrollStatusArr[0]"><a
                [ngClass]="{'disable-url':  !deviceSummaryData[0].fan.emmAccountId}" style="font-size: 14px"
                (click)="updateExistingDate(0)" href="javascript:void(0)">
                {{ deviceInventoryData.enroll }}
              </a>
            </ng-container>
          </div>
          <div *ngIf="enrollStatusArr && !enrollStatusArr[0]">
            {{ deviceInventoryData.existingDevices }}
            {{ deviceInventoryData.enrolled }}
          </div>
        </div>

        <div class="remove-acct">
          <a [ngClass]="{'disable-url':  !deviceSummaryData[0].fan.emmAccountId}" (click)="cancelPaticipation(0)"
            href="javascript:void(0)" [checkRole]="
              deviceInventoryData.fieldPermissions.cancelParticipation
            ">
            {{ deviceInventoryData.cancelParticipation }}
          </a>
        </div>
      </div>

      <!-- second proram render here -->
      <div class="multi-prog2" *ngIf="deviceSummaryData.length >= 2">
        <div class="tileHeader" *ngIf="deviceSummaryData[1].fan.emmProductCode === 'DMPGZTP'">
          <strong>Android™ Zero-touch</strong>
        </div>
        <div class="tileHeader" *ngIf="deviceSummaryData[1].fan.emmProductCode === 'DMPSKME'">
          <strong>Knox Mobile Enrollment</strong>
        </div>
        <div class="tileHeader" *ngIf="deviceSummaryData[1].fan.emmProductCode === 'DMPAABM'">
          <strong>Apple Business</strong>
        </div>
        <div style="margin-bottom: 20px" class="program-label"
          *ngIf="deviceSummaryData[1].fan.emmProductCode === 'DMPGZTP'">
          <span class="programEnroll smallMobile">GOOGLE ID: {{ deviceSummaryData[1].fan.emmAccountId }}</span>
        </div>
        <div style="margin-bottom: 20px" class="program-label"
          *ngIf="deviceSummaryData[1].fan.emmProductCode === 'DMPSKME'">
          <span class="programEnroll smallMobile">Knox Enrollment ID:
            {{ deviceSummaryData[1].fan.emmAccountId }}</span>
        </div>
        <div style="margin-bottom: 20px" class="program-label"
          *ngIf="deviceSummaryData[1].fan.emmProductCode === 'DMPAABM'">
          <span class="programEnroll smallMobile">Apple Organization ID:
            {{ deviceSummaryData[1].fan.emmAccountId ? deviceSummaryData[1].fan.emmAccountId : "Pending"}}
            <!--  u2-4290 >>> <i class="tooltip-icon tooltip"  style="font-style: normal"
            > -->
            <!-- {{ deviceSummaryData[1].fan.emmAccountId ? deviceSummaryData[1].fan.emmAccountId : "Pending"}} -->
            <!-- <span class="tooltiptext">Please review Apple emails to finalize enrollment.</span></i> -->
          </span>
          <ng-container *ngIf="!addpAllow && abm"><a [ngClass]="{'disable-url': !deviceSummaryData[1].fan.emmAccountId}"
              class="abm-change-link"
              (click)="selectedFan(deviceSummaryData[1].fan.emmAccountId)">
              {{ deviceInventoryData.change }}
            </a></ng-container>
        </div>
        <div *ngIf="enrollStatusArr.length > 0 && enrollStatusArr[1]">
          <span class="programEnroll smallMobile">{{ deviceInventoryData.existingDevices }}
            {{ deviceInventoryData.existingDevicesValue }}</span>
          <ng-container *ngIf="enrollStatusArr.length > 0 && enrollStatusArr[1] && !addpAllow"><a
              [ngClass]="{'disable-url':  !deviceSummaryData[1].fan.emmAccountId}" style="font-size: 14px"
              (click)="updateExistingDate(1)" href="javascript:void(0)">
              {{ deviceInventoryData.enroll }}
            </a>
          </ng-container>
        </div>
        <div class="program-label" *ngIf="enrollStatusArr && !enrollStatusArr[1]">
          {{ deviceInventoryData.existingDevices }}
          {{ deviceInventoryData.enrolled }}
        </div>

        <div class="remove-acct">
          <a [ngClass]="{'disable-url':!deviceSummaryData[1].fan.emmAccountId}" (click)="cancelPaticipation(1)"
            href="javascript:void(0)" [checkRole]="
              deviceInventoryData.fieldPermissions.cancelParticipation
            ">
            {{ deviceInventoryData.cancelParticipation }}
          </a>
        </div>
      </div>

      <!-- third program render here -->
      <div class="multi-prog2" *ngIf="deviceSummaryData.length >= 3">
        <div class="tileHeader" *ngIf="deviceSummaryData[2].fan.emmProductCode === 'DMPGZTP'">
          <strong>Android™ Zero-touch</strong>
        </div>
        <div class="tileHeader" *ngIf="deviceSummaryData[2].fan.emmProductCode === 'DMPSKME'">
          <strong>Knox Mobile Enrollment</strong>
        </div>
        <div class="tileHeader" *ngIf="deviceSummaryData[2].fan.emmProductCode === 'DMPAABM'">
          <strong>Apple Business</strong>
        </div>
        <div style="margin-bottom: 20px" class="program-label"
          *ngIf="deviceSummaryData[2].fan.emmProductCode === 'DMPGZTP'">
          <span class="programEnroll smallMobile">GOOGLE ID: {{ deviceSummaryData[2].fan.emmAccountId }}</span>
        </div>
        <div style="margin-bottom: 20px" class="program-label"
          *ngIf="deviceSummaryData[2].fan.emmProductCode === 'DMPSKME'">
          <span class="programEnroll smallMobile">Knox Enrollment ID:
            {{ deviceSummaryData[2].fan.emmAccountId }}</span>
        </div>
        <div style="margin-bottom: 20px" class="program-label"
          *ngIf="deviceSummaryData[2].fan.emmProductCode === 'DMPAABM'">
          <span class="programEnroll smallMobile">Apple Organization ID:
            {{ deviceSummaryData[2].fan.emmAccountId ? deviceSummaryData[2].fan.emmAccountId : "Pending"}}
          </span>
          <ng-container *ngIf="!addpAllow && abm"><a [ngClass]="{'disable-url': !deviceSummaryData[2].fan.emmAccountId}"
              class="abm-change-link"
              (click)="selectedFan(deviceSummaryData[2].fan.emmAccountId)">
              {{ deviceInventoryData.change }}
            </a></ng-container>
        </div>
        <div *ngIf="enrollStatusArr.length > 2 && enrollStatusArr[2]">
          <span class="programEnroll smallMobile">{{ deviceInventoryData.existingDevices }}
            {{ deviceInventoryData.existingDevicesValue }}</span>
          <ng-container *ngIf="enrollStatusArr.length > 2 && enrollStatusArr[2] && !addpAllow"><a
              [ngClass]="{'disable-url':  !deviceSummaryData[2].fan.emmAccountId}" style="font-size: 14px"
              (click)="updateExistingDate(2)" href="javascript:void(0)">
              {{ deviceInventoryData.enroll }}
            </a>
          </ng-container>
        </div>
        <div class="program-label" *ngIf="enrollStatusArr && enrollStatusArr.length > 2 && !enrollStatusArr[2]">
          {{ deviceInventoryData.existingDevices }}
          {{ deviceInventoryData.enrolled }}
        </div>

        <div class="remove-acct">
          <a [ngClass]="{'disable-url':!deviceSummaryData[2].fan.emmAccountId}" (click)="cancelPaticipation(2)"
            href="javascript:void(0)" [checkRole]="
              deviceInventoryData.fieldPermissions.cancelParticipation
            ">
            {{ deviceInventoryData.cancelParticipation }}
          </a>
        </div>
      </div>

      <div class="multi-prog2" *ngIf="deviceSummaryData.length < 3 && remainingPrograms > 0">
        <div class="tileHeader"><strong>This account has {{remainingPrograms}} program{{remainingPrograms > 1 ? 's' : ''}} to register</strong></div>
        <p>Once you add a new program it will show up here.</p>
        <button (click)="navigate('/productselection')" class="btn btn-secondary">
          Add account
        </button>
      </div>
    </section>
    <!-- <div class='download-terms'>
           <a [checkRole]='deviceInventoryData.fieldPermissions.downloadTermsandConditions' href='javascript:void(0)' >{{deviceInventoryData.downloadTermsandConditions}}</a>
       </div>  -->
    <div class="clearfix"></div>
    <br />
    <h2><strong>Manage Devices</strong></h2>

    <!-- <button (click)=selectStatusOption($event)>Click here</button> -->
    <hr />
  </div>
  <div *ngIf="deviceInventoryData && ctnTable && singleFanInventory.fan" class="device-inventory">
    <section class="panel-container">
      <section class="progress-bar" style="margin-bottom: 67px" *ngIf="singleFanInventory.fan">
        <div class="status-bar" *ngIf="!singleFanInventory.hideDeviceChart">
          <strong>
            <app-status-bar [data]="progressChartData" [leftLabel]="leftLabel"></app-status-bar>
          </strong>
        </div>
        <div class="legend-data" *ngIf="progressChartData.length > 0">
          <app-legend class="col-sm-6 col-md-6" [data]="legendData.left"></app-legend>
          <app-legend class="col-sm-6 col-md-6" [data]="legendData.right"></app-legend>
        </div>
      </section>
      <div class="clearfix"></div>
      <hr />
      <section>
        <br />
        <div class="nav-links">
          <div class="oem-sms" *ngFor="let nav of deviceInventoryData.navOEMLinks">
            <button class="link-button" type="button" (click)="navigate(nav.route)" [disabled]="nav.disable">
              <figure class="link-figure">
                <img [src]="nav.imgUrl" alt="image icon for {{ nav.label }}" />
              </figure>
              <span class="link-text"><a [innerHtml]="nav.label"></a></span>
            </button>
          </div>
          <!-- code for Accesories icon  -->
          <div class="oem-accesories" *ngIf="isPremier">
            <button class="link-button" type="button" (click)="gotoAccesories()" [disabled]="false">
              <figure class="link-figure">
                  <img src="assets\img\Accessories icon new 2.png" alt="image icon for Accesories Icon" />
              </figure>
              <span class="link-text"><a>Purchase Accessories</a></span>
            </button>
          </div>
        </div>        
      </section>

      <div class="clearfix"></div>
    </section> 
    <hr />
    <br />

    <div class="searchcontent greybox">
      <div class="container-box-sm">
        <div class="row">
          <h3 class="col-6 seachbox-heading">Find Devices</h3>
          <a href="javascript:void(0)" class="col-6 btn-link clear-btn pull-right" (keydown.enter)="clearAll()"
            (click)="clearAll()">Clear all</a>
           </div>
        <div class="row">
          <div class="col-sm-12 col-md-4 inputContent">
            <label for="ctnNumber">Wireless user</label>
            <div class="input-field">
              <input type="text" (keyup)="checkPattern($event)" class="form-control field" id="ctnNumber"
                maxlength="10" />
            </div>
            <div class="email-error-field" *ngIf="isctnNumberInvalid">
              <div class="text-danger">Invalid Data</div>
            </div>
          </div>

          <div class="col-sm-12 col-md-4 inputContent">
            <label for="imei">IMEI</label>
            <div class="input-field">
              <input type="text" (keyup)="checkPattern($event)" class="form-control" id="imei" maxlength="15" />
            </div>
            <div class="email-error-field" *ngIf="isimeiNumberInvalid">
              <div class="text-danger">Invalid Data</div>
            </div>
          </div>

          <div class="col-sm-12 col-md-4 inputContent">
            <label for="deviceModel">Device Model</label>
            <div class="input-field">
              <input type="text" (keyup)="checkPattern($event)" class="form-control" id="deviceModel" />
            </div>
            <div class="email-error-field" *ngIf="isModelInvalid">
              <div class="text-danger">Invalid Data</div>
            </div>
          </div>
        </div>
        <br>
        <div class="row">
          <div class="col-sm-12 col-md-4 dropDown statusDropdown">
            <div class="dropDownInput">
              <app-dropdown [labelId]="'statusLabel'" [placeholder]="'Select'" [placeholderAriaLabel]="'Status'"
                [options]="statusOptions" [prePopulateValue]="defaultStatus" (selectEmit)="selectStatusOption($event)">
              </app-dropdown>
            </div>
          </div>
          <div class="col-sm-12 col-md-4 dropdown-tm">
            <div class="dropDownInput">
              <app-dropdown [labelId]="'groupLabel'" [placeholder]="'Select'" [placeholderAriaLabel]="'Group'"
                [options]="groupsOptions" [prePopulateValue]="defaultGroup" (selectEmit)="selectGroupOption($event)">
              </app-dropdown>
            </div>
          </div>
          <button class="col-sm-12 col-md-4 btn btn-secondary search-btn" tabindex="0"
            (click)="searchDevices($event)">Search</button>
        </div>
      </div>
    </div>
    <!-- <p *ngIf = "showNumberOfRowsSelected" >{{numberOfRowsSelected}} Selected of {{totalNumberOfRecords}}</p>
      <app-custom-grid-extended [gridOptions]='gridOptions' (onDataChange)="onRowClick($event)"></app-custom-grid-extended> -->
    <!-- <div class="row searchcontent greybox">
      <div class="row enrollDateInfo">
        <div class="greybox-text">
          {{ deviceInventoryData.enrollDatePopup.newPageContent }}
        </div>

        <div class="flex-row">
          <div class="search-placeholder"></div>
        </div>
      </div>
    </div> -->

    <div *ngIf="showEnrollDetailsModal">
      <app-modal [showModal]="showEnrollDetailsModal">
        <app-confirm-modal [modalPopupObject]="enrollDatePopup" [triggerElement]="eventEmit"
          (modalOutput)="closePopupModal($event)">
        </app-confirm-modal>
      </app-modal>
    </div>
    <div></div>
    <app-custom-grid-extended [gridOptions]="gridOptions" [filterValue]="filterValue"
      (gridEvent)="gridEventChanges($event)" (onDataChange)="onRowClick($event)"></app-custom-grid-extended>
    <div *ngIf="showPopup">
      <app-modal [showModal]="showPopup" [modalClass]="modalClass">
        <app-confirm-modal [modalPopupObject]="confirmModalPopup" [triggerElement]="eventEmit"
          (modalOutput)="closeModal($event)">
        </app-confirm-modal>
      </app-modal>
    </div>
    <!--Report pop up functionality -->
    <div *ngIf="showReportPopup">
      <app-modal [showModal]="showReportPopup" [modalClass]="modalClass">
        <app-report [modalPopupObject]="overviewModalPopup" [triggerElement]="eventEmit"
          (modalOutput)="closeReportPopup($event)">
        </app-report>
      </app-modal>
    </div>
    <div *ngIf="showOverviewModal">
      <app-modal [showModal]="showOverviewModal" [modalClass]="modalClass">
        <div class="model-cover terms">
          <div class="model-box">
            <div class="modal-header">
              <div class="corner-button">
                <button class="close" aria-label="Close" (click)="closeOverviewModal()">
                  x
                </button>
              </div>
              <att-gvp [attr.video]="videoId"></att-gvp>
            </div>
          </div>
        </div>
      </app-modal>
    </div>
    <!-- <div class="accordion-section" *ngIf="supportArticle">
      <app-accordion [accordion]="options" [accordionController]=false>
        <app-accordion-list *ngFor="let option of options; let i=index " [option]='option' [isSubAccordion]=true>
          <div class="support-content mediaStop" id="player"
            *ngFor="let article of this.article.availableArticle; let i=index">
             <a href="javascript:void(0)"  (click)="getSupportContent(i)" >{{article.name}}</a> -->
    <!-- <att-gvp *ngIf="article.url" [attr.video]="article.url"></att-gvp>
          </div>
        </app-accordion-list>
      </app-accordion>
    </div> -->
  </div>
</main>

<div *ngIf="deviceInventoryData && data && showLIC" class="lic-contest">
  <div class="main-wrapper" aria-labelledby="deviceInventoryLICContainer">
    <h3 id="deviceInventoryLICContainer">
      {{ deviceInventoryData.LIC.console }}
    </h3>
    <div class="row">
      <div class="col-sm-12 col-md-12 col-md-size lic-container">
        <div>
          <label>{{ deviceInventoryData.LIC.fan }}:</label>
          <abbr>{{ singleFanInventory.fan }}</abbr>
        </div>
        <div>
          <label>{{ deviceInventoryData.LIC.provider }}:</label>
          <abbr>{{ data.emmProvider }}</abbr>
        </div>
        <div>
          <label>{{ deviceInventoryData.LIC.tenant }}:</label>
          <abbr>{{ data.emmTenantId }}</abbr>
        </div>
      </div>
    </div>
  </div>
</div>
<app-mobile-pivot [pivots]="pivots"></app-mobile-pivot>